var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { useBranchesGetAll } from "../../fnx/branches/branchesGetAll";
import { useBranchesPatch } from "../../fnx/branches/branchesPatch";
import { useBranchesPost } from "../../fnx/branches/branchesPost";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { branchesClearData, branchesPatchClearData, branchesPostClearData, } from "../../store/branches/actions";
import { Columns, dataFormBranch } from "./branchDTO";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { themeCore } from "../../assets/themes/theme";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var BranchAdmin = function () {
    var _a, _b;
    var dispatch = useDispatch();
    var _c = useState([]), list = _c[0], setList = _c[1];
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(false), triggerPost = _e[0], setTriggerPost = _e[1];
    var _f = useState(false), triggerPatch = _f[0], setTriggerPatch = _f[1];
    var _g = useState(false), openModalDelete = _g[0], setOpenModalDelete = _g[1];
    var _h = useState(""), nameSearch = _h[0], setNameSearch = _h[1];
    var _j = useState({ data: {} }), bodyRequest = _j[0], setBodyRequest = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var branchId = React.useState(lsLogin.getUserLoginStored().branchId)[0];
    var _k = useState(false), isUpdate = _k[0], setIsUpdate = _k[1];
    var _l = useState(false), openDrawer = _l[0], setOpenDrawer = _l[1];
    var _m = useState(null), itemModal = _m[0], setitemModal = _m[1];
    var _o = useState(dataFormBranch), dataForm = _o[0], setDataForm = _o[1];
    var _p = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _p[0], setSeeToast = _p[1];
    var _q = useBranchesGetAll(trigger, clientId, nameSearch, ""), responseBranches = _q.responseBranches, errorBranches = _q.errorBranches, loadingBranches = _q.loadingBranches;
    var _r = useBranchesPost(triggerPost, bodyRequest), responseBranchesPost = _r.responseBranchesPost, errorBranchesPost = _r.errorBranchesPost, loadingBranchesPost = _r.loadingBranchesPost;
    var _s = useBranchesPatch(triggerPatch, bodyRequest, (_a = bodyRequest === null || bodyRequest === void 0 ? void 0 : bodyRequest.data) === null || _a === void 0 ? void 0 : _a.id), responseBranchesPatch = _s.responseBranchesPatch, errorBranchesPatch = _s.errorBranchesPatch, loadingBranchesPatch = _s.loadingBranchesPatch;
    var _t = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _t.responseDeleteEntity, loadingDeleteEntity = _t.loadingDeleteEntity, errorDeleteEntity = _t.errorDeleteEntity;
    useEffect(function () {
        if (!responseBranches) {
            setTrigger(true);
        }
    }, []);
    var callBranches = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callBranches();
    }, []);
    useEffect(function () {
        if (responseBranches) {
            var list_1 = responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) { return ({
                id: item.id,
                Code: item.code,
                Name: item.name,
            }); });
            setList(list_1);
        }
        dispatch(branchesClearData());
        setTrigger(false);
    }, [responseBranches, errorBranches]);
    useEffect(function () {
        var _a, _b, _c;
        if (responseBranchesPost) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setTriggerPost(false);
            setTrigger(true);
        }
        else if (errorBranchesPost) {
            var error = errorBranchesPost;
            var message = "Error al crear";
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.errors[0].message;
            }
            else {
                message = (_c = error.response) === null || _c === void 0 ? void 0 : _c.message;
            }
            setSeeToast({
                show: true,
                message: message,
                type: typeAlert.error,
            });
            setTriggerPost(false);
            setTrigger(false);
        }
        dispatch(branchesPostClearData());
    }, [responseBranchesPost, errorBranchesPost]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setOpenModalDelete(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (responseBranchesPatch) {
            setSeeToast({
                show: true,
                message: "Actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenDrawer(false);
            setTriggerPatch(false);
            setTrigger(true);
        }
        else if (errorBranchesPatch) {
            setSeeToast({
                show: true,
                message: errorBranchesPatch === null || errorBranchesPatch === void 0 ? void 0 : errorBranchesPatch.message,
                type: typeAlert.error,
            });
            setTriggerPatch(false);
        }
        dispatch(branchesPatchClearData());
    }, [responseBranchesPatch, errorBranchesPatch]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    useEffect(function () {
        if (nameSearch) {
            setTrigger(true);
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var filterStatus = function (item) {
        // const idUser = item?.user.map((item: any) => item.id).join(",");
        // setTrigger(true);
    };
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { id: row.id, Code: row.Code, Name: row.Name }));
    };
    var handleSubmit = function (dataItem) {
        if (isUpdate) {
            setBodyRequest({
                data: {
                    id: dataItem.id,
                    name: dataItem.Name,
                    code: dataItem.Code,
                    status: "1",
                },
            });
            setTriggerPatch(true);
        }
        else {
            setBodyRequest({
                data: { name: dataItem.Name, code: dataItem.Code, status: "1" },
            });
            setTriggerPost(true);
        }
        setOpenDrawer(false);
    };
    var handleCloseModal = function () {
        setOpenDrawer(false);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenDrawer(true);
        setDataForm(__assign(__assign({}, dataForm), { id: "", Code: "", Name: "" }));
    };
    var onClickContextMenu = function (opt, item) {
        if (opt.id === "1") {
            showEdit(item.row);
            setIsUpdate(true);
            setOpenDrawer(true);
        }
        else if (opt.id === "2") {
            setitemModal(item);
            setOpenModalDelete(true);
        }
        else if (opt.id === "3") {
            setitemModal(item);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleDelete = function () {
        var _a;
        setOpenModalDelete(false);
        dispatch(deleteEntity({
            id: (_a = itemModal === null || itemModal === void 0 ? void 0 : itemModal.row) === null || _a === void 0 ? void 0 : _a.id,
            entity: "BranchEntity",
            idUser: clientId,
        }));
    };
    var ColumnsRegion = Columns(onClickContextMenu);
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: loadingBranches ||
                    loadingBranchesPost ||
                    loadingBranchesPatch ||
                    loadingDeleteEntity, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: loadingBranches ||
                    loadingBranchesPost ||
                    loadingBranchesPatch ||
                    loadingDeleteEntity
                    ? "Eliminando sucursal"
                    : "Cargando sucursales...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(View
            // Props Admin
            , { 
                // Props Admin
                title: "Sucursales", columns: ColumnsRegion, buttonTextAdd: "Agregar sucursal", onClickAdd: handleOnClickAdd, 
                // Props Form
                titleForm: "Edici\u00F3n de sucursal", dataForm: dataForm, editMode: false, buttonText: "Guardar", onSaveData: handleSubmit, 
                // Props Drawer
                openDrawer: openDrawer, textDescription: "Lorem ipsum dolor sit amet consectetur. Eu arcu venenatis diam convallis non faucibus sem fringilla suspendisse. Vitae pharetra enim quis augue enim. Tristique eu cras consectetur tincidunt sed velit. In tristique facilisis leo viverra. In malesuada diam ante nec mauris. Id volutpat enim parturient penatibus eu orci. Neque risus morbi diam", onCloseDrawer: handleCloseModal, 
                // Props Filter
                filterStatus: filterStatus, searchFilter: searchFilter, onCloseSearch: onCloseSearch, list: list, modalTitle: (_b = itemModal === null || itemModal === void 0 ? void 0 : itemModal.row) === null || _b === void 0 ? void 0 : _b.Name, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, clickView: clickView, onSubmit: handleDelete, onClickContextMenu: onClickContextMenu })] }));
};
export default BranchAdmin;
